module.exports = __webpack_public_path__ + "static/media/2020.6.5邻里矛盾调解.835a37a7.jpg";